(function () {
  function getScopedPages() {
    return document.querySelectorAll('[data-alilao-collection-page]');
  }

  function preserveQuery(targetUrl) {
    var url = new URL(targetUrl, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);

    currentParams.forEach(function (value, key) {
      if (key !== 'page' && !url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });

    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
  }

  function navigate(targetUrl) {
    window.location.href = preserveQuery(targetUrl);
  }

  function parseNumericInput(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  function setPriceInputs(scope) {
    var params = new URLSearchParams(window.location.search);
    var minInput = scope.querySelector('[data-price-min]');
    var maxInput = scope.querySelector('[data-price-max]');

    if (minInput) {
      minInput.value = params.get('filter.v.price.gte') || '';
    }

    if (maxInput) {
      maxInput.value = params.get('filter.v.price.lte') || '';
    }
  }

  function bindSort(scope) {
    var sortSelect = scope.querySelector('[data-collection-sort-select]');
    var params;
    var currentSort;

    if (!sortSelect) {
      return;
    }

    params = new URLSearchParams(window.location.search);
  currentSort = params.get('sort_by') || sortSelect.getAttribute('data-current-sort') || sortSelect.value || 'manual';
    sortSelect.value = currentSort;

    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);

      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');

      window.location.href = url.pathname + '?' + url.searchParams.toString();
    });
  }

  function bindPriceForm(scope) {
    var form = scope.querySelector('[data-collection-price-form]');

    if (!form) {
      return;
    }

    form.addEventListener('submit', function (event) {
      var minInput = form.querySelector('[data-price-min]');
      var maxInput = form.querySelector('[data-price-max]');
      var url = new URL(window.location.href);
      var minValue = parseNumericInput(minInput ? minInput.value : '');
      var maxValue = parseNumericInput(maxInput ? maxInput.value : '');

      event.preventDefault();

      if (minValue) {
        url.searchParams.set('filter.v.price.gte', minValue);
      } else {
        url.searchParams.delete('filter.v.price.gte');
      }

      if (maxValue) {
        url.searchParams.set('filter.v.price.lte', maxValue);
      } else {
        url.searchParams.delete('filter.v.price.lte');
      }

      url.searchParams.delete('page');
      window.location.href = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
    });
  }

  function bindTagFilters(scope) {
    var tagInputs = scope.querySelectorAll('input[data-tag-url]');
    var index;

    for (index = 0; index < tagInputs.length; index += 1) {
      tagInputs[index].addEventListener('change', function () {
        var checkbox = this;
        var targetUrl = checkbox.getAttribute('data-tag-url');
        var groupName = checkbox.getAttribute('data-group');
        var groupKind = checkbox.getAttribute('data-group-kind');
        var groupedInputs;
        var activeInGroup = null;
        var groupedIndex;

        if (!targetUrl) {
          return;
        }

        if (checkbox.checked && groupName && groupKind === 'grouped') {
          groupedInputs = scope.querySelectorAll('input[data-group-kind="grouped"][data-group="' + groupName.replace(/"/g, '\\"') + '"]');

          for (groupedIndex = 0; groupedIndex < groupedInputs.length; groupedIndex += 1) {
            if (groupedInputs[groupedIndex] !== checkbox && groupedInputs[groupedIndex].checked) {
              activeInGroup = groupedInputs[groupedIndex];
              break;
            }
          }

          if (activeInGroup && activeInGroup !== checkbox && activeInGroup.getAttribute('data-handle') && checkbox.getAttribute('data-handle')) {
            targetUrl = window.location.pathname.replace(activeInGroup.getAttribute('data-handle'), checkbox.getAttribute('data-handle'));
          }
        }

        navigate(targetUrl);
      });
    }
  }

  function initCollectionPage(scope) {
    setPriceInputs(scope);
    bindSort(scope);
    bindPriceForm(scope);
    bindTagFilters(scope);
  }

  function init() {
    var pages = getScopedPages();
    var index;

    for (index = 0; index < pages.length; index += 1) {
      initCollectionPage(pages[index]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();